import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, AlertTriangle, TrendingDown } from 'lucide-react';

interface FlagsDisplayProps {
  flags: string[];
}

const flagDetails: Record<string, { 
  label: string; 
  description: string; 
  icon: React.ReactNode;
  variant: 'destructive' | 'default' | 'secondary';
}> = {
  'low-yield': {
    label: 'Low Yield',
    description: 'Suggested price is below 10% of nominal value',
    icon: <TrendingDown className="h-4 w-4" />,
    variant: 'destructive'
  },
  'below-threshold': {
    label: 'Below Threshold',
    description: 'IRR is below half of the net target percentage',
    icon: <AlertCircle className="h-4 w-4" />,
    variant: 'destructive'
  },
  'stale-book': {
    label: 'Stale Book',
    description: 'High concentration of payday loans with low payment recency',
    icon: <AlertTriangle className="h-4 w-4" />,
    variant: 'secondary'
  }
};

export const FlagsDisplay = ({ flags }: FlagsDisplayProps) => {
  if (!flags || flags.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Portfolio Flags</CardTitle>
        <CardDescription>
          Risk factors and considerations for this valuation
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {flags.map((flag) => {
          const detail = flagDetails[flag];
          if (!detail) return null;

          return (
            <div key={flag} className="flex items-start gap-3 rounded-lg border p-3">
              <div className="mt-0.5">{detail.icon}</div>
              <div className="flex-1 space-y-1">
                <div className="flex items-center gap-2">
                  <Badge variant={detail.variant}>{detail.label}</Badge>
                </div>
                <p className="text-sm text-muted-foreground">
                  {detail.description}
                </p>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
